import * as React from "react";
import { FormattedMessage } from "react-intl";
import { useTheme } from "react-jss";
import contentStyles from "./styles";
import { AC_TERMS_BUSINESS_TRAVEL_LINK, AC_TERMS_PRIVACY_POLICY_LINK, AC_TERMS_CARRIAGE_LINK, AC_TERMS_AEROPLAN_LINK } from "../../../../constants/appConstants";

const TravelerContent = () => {
  const theme = useTheme();
  const classes = contentStyles({ theme });

  const richTextValues = {
    h3: (chunks) => <h3 className={classes.h3}>{chunks}</h3>,
    h4: (chunks) => <h4 className={classes.h4}>{chunks}</h4>,
    p: (chunks) => <p className={classes.p}>{chunks}</p>,
    ul: (chunks) => <ul className={classes.ul}>{chunks}</ul>,
    uldash: (chunks) => <ul className={classes.ulDash}>{chunks}</ul>,
    li: (chunks) => <li className={classes.li}>{chunks}</li>,
    strong: (chunks) => <span className={classes.strong}>{chunks}</span>,
    underline: (chunks) => <span className={classes.underline}>{chunks}</span>,
    businessTravelLink: (chunks) => (
      <a className={classes.a} href={AC_TERMS_BUSINESS_TRAVEL_LINK} target="_blank" rel="noopener noreferrer">
        {chunks}
      </a>
    ),
    privacyPolicyLink: (chunks) => (
      <a className={classes.a} href={AC_TERMS_PRIVACY_POLICY_LINK} target="_blank" rel="noopener noreferrer">
        {chunks}
      </a>
    ),
    carriageLink: (chunks) => (
      <a className={classes.a} href={AC_TERMS_CARRIAGE_LINK} target="_blank" rel="noopener noreferrer">
        {chunks}
      </a>
    ),
    aeroplanLink: (chunks) => (
      <a className={classes.a} href={AC_TERMS_AEROPLAN_LINK} target="_blank" rel="noopener noreferrer">
        {chunks}
      </a>
    ),
  };

  return (
    <div className={classes.section}>
      <FormattedMessage id="acTermsModal.traveler.intro" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section1" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section2" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section3" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section4" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section5" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section6" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section7" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section8" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section9" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section10" values={richTextValues} />
      <FormattedMessage id="acTermsModal.traveler.section11" values={richTextValues} />
    </div>
  );
};

export default TravelerContent;
